import { Box, useTheme } from '@mui/material';
import { t } from 'i18next';
import { getSentimentsColor } from '@pages/Admin/Campaign/ui/utils';
import { SentimentDto } from '@shared/services/apiService/apiService';
import { IconIndicatorFlag } from '@shared/assets/images/svgs';

interface WrappedSentimentFlagProps {
  sentiments: SentimentDto[] | undefined;
}

/* eslint-disable react/prop-types */
export const WrappedSentimentFlag: React.FC<WrappedSentimentFlagProps> = ({ sentiments }) => {
  const theme = useTheme();

  if (!sentiments?.length) {
    return <>{t('campaignPage.unavailable')}</>;
  }

  return (
    <Box
      display={'flex'}
      justifyContent="center"
      sx={{ '& path': { stroke: getSentimentsColor(sentiments, theme) } }}>
      <IconIndicatorFlag />
    </Box>
  );
};
